// extracted by mini-css-extract-plugin
export default {"form":"ModalForm_form__Jpcho","modal_bottom":"ModalForm_modal_bottom__kwnO7","modal_method_name":"ModalForm_modal_method_name__A3g9h","modal_tips":"ModalForm_modal_tips__8TW1j"};